import { render, staticRenderFns } from "./org-contacts-modal.vue?vue&type=template&id=a5555840&scoped=true&"
import script from "./org-contacts-modal.vue?vue&type=script&lang=js&"
export * from "./org-contacts-modal.vue?vue&type=script&lang=js&"
import style0 from "./org-contacts-modal.vue?vue&type=style&index=0&id=a5555840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5555840",
  null
  
)

export default component.exports